import { render, staticRenderFns } from "./NotificationEditView.vue?vue&type=template&id=0626d55f"
import script from "./NotificationEditView.vue?vue&type=script&lang=ts"
export * from "./NotificationEditView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports